import {
  V1ResourceRateResource,
  useListResourceRatesForAccountQuery,
} from "@generated";
import { RootState } from "@reducers/rootReducer";
import { useSelector } from "react-redux";

const useListResourceRates = (rateTableId) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data, error, isLoading, refetch } =
    useListResourceRatesForAccountQuery({
      slug: accountSlug,
      page: { size: 1000 },
      filter: { "rate-table": rateTableId || undefined },
      include: ["resource", "line-of-business"],
    });

  let resourceRates: V1ResourceRateResource[] = [];
  let customError: string | null = null;
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  if (data?.data) {
    try {
      resourceRates = data?.data;

      if (!data?.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data?.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data?.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        recordCount: data?.meta["record-count"],
        pageCount: data?.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    resourceRates,
    resourceRatesError: error || customError,
    resourceRatesLoading: isLoading,
    pageMeta,
    resourceRatesRefetch: refetch,
  };
};

export default useListResourceRates;
